import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CurrencyService } from '@core/services/currency.service';

export const currencyFormattingResolver: ResolveFn<void> = () => {
  return inject(CurrencyService).setCurrencyFormatting();
};
